/**
 * Conditions générales d'utilisation (ARTO-59) : le catalogue des versions, et
 * les règles du mécanisme dormant (CGU, articles 1 et 2).
 *
 * Capacité implémentée, dormante tant qu’aucune version n’est en vigueur :
 * chaque utilisateur accepte les CGU par une action expresse ; une nouvelle
 * version SUBSTANTIELLE est soumise à acceptation à la première connexion qui
 * suit son entrée en vigueur, sans interrompre les sessions déjà ouvertes. Une
 * version de forme (`substantielle: false`) devient le texte présenté, sans
 * redemander d'acceptation à qui a accepté la précédente.
 *
 * Le catalogue est en ordre CHRONOLOGIQUE, et une version n'en sort jamais :
 * une acceptation enregistrée doit toujours retrouver son rang. Les textes
 * eux-mêmes vivent dans la régie (`apps/regie/src/cgu/textes/`), extraits du
 * site par `apps/regie/scripts/cgu.mjs`, qui en calcule les empreintes.
 */
export const LANGUES_CGU = ['fr', 'en'];
export const CGU_VERSIONS = [
    {
        version: '2026-10-04',
        // DÉCISION (ARTO-59) — `null` : le texte attend la relecture de l'avocat
        // et n'est pas publié. Tant que cette date n'est pas posée, le mécanisme
        // est DORMANT : aucune session n'est confinée, aucune version ne
        // s'accepte. Le jour de la publication, c'est la seule ligne à écrire —
        // un instant complet, fuseau compris (`'2026-11-05T00:00:00+01:00'`).
        enVigueurLe: null,
        substantielle: true,
        empreintes: {
            fr: '5e70674d166db441efefa4c3cdc17fd58f66ce1eaab2e2e92705e2343e63e210',
            en: 'c186b5bc97edc93e247a0627ccbc32531354711140ee6b5c6e301d6b5a169d89',
        },
    },
];
function estEnVigueur(entree, maintenant) {
    if (entree.enVigueurLe === null)
        return false;
    // Une date illisible n'est jamais tenue pour passée.
    const instant = Date.parse(entree.enVigueurLe);
    return Number.isFinite(instant) && instant <= maintenant.getTime();
}
/** La dernière version entrée en vigueur, substantielle ou non : celle qu'on présente et qu'on accepte. */
export function versionEnVigueur(catalogue, maintenant) {
    let courante = null;
    for (const entree of catalogue)
        if (estEnVigueur(entree, maintenant))
            courante = entree;
    return courante;
}
/** La dernière version SUBSTANTIELLE entrée en vigueur : celle qu'une nouvelle session exige. */
export function versionExigee(catalogue, maintenant) {
    let exigee = null;
    for (const entree of catalogue)
        if (entree.substantielle && estEnVigueur(entree, maintenant))
            exigee = entree;
    return exigee;
}
/**
 * Vrai quand la version acceptée vaut pour la version exigée : son rang dans
 * le catalogue est au moins le sien. Une version inconnue — l'acceptée ou
 * l'exigée — ne satisfait jamais : échec fermé.
 */
export function acceptationSatisfait(catalogue, versionAcceptee, versionExigeeParLaSession) {
    if (!versionAcceptee)
        return false;
    const rangAccepte = catalogue.findIndex((entree) => entree.version === versionAcceptee);
    const rangExige = catalogue.findIndex((entree) => entree.version === versionExigeeParLaSession);
    return rangAccepte >= 0 && rangExige >= 0 && rangAccepte >= rangExige;
}
//# sourceMappingURL=cgu.js.map